import React from "react";
import { ExclamationCircleIcon } from "@heroicons/react/solid";

interface DisplayErrorsProps {
  message?: string;
}

// diplay errors component for handle error ui
const DisplayErrors: React.FC<DisplayErrorsProps> = ({ message }) => {
  return (
    <div className="flex items-center gap-2 text-red-600 font-medium">
      <ExclamationCircleIcon className="primary-icon" />
      <p>{message ?? "something wrong happen"}</p>
    </div>
  );
};

export default DisplayErrors;
